import { InfoOutline } from '@randstad-lean-mobile-factory/react-components-ui-shared';
import classnames from 'classnames';

import { Base } from '../Base';
import { Props } from '../Base/Base.types';

import styles from './Info.module.scss';

export const Info = ({ children, className }: Props) => (
  <Base icon={<InfoOutline />} className={classnames(styles.info, className)}>
    {children}
  </Base>
);
